import React from 'react';

const chunkSubstr = (str, size) => {
  const numChunks = Math.ceil(str.length / size);
  const chunks = new Array(numChunks);

  for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
    chunks[i] = str.substr(o, size);
  }

  return chunks;
};

export const splitLongText = (text, chunkSize = 20) => {
  if (!text) {
    return <span></span>;
  }

  return text.split(' ').map((word, wordIndex, array) => {
    const chunks = chunkSubstr(word, chunkSize);
    return (
      <React.Fragment key={wordIndex}>
        {chunks.map((chunk, i) => (
          <span className="text-chunk" key={i}>
            {chunk}
          </span>
        ))}
        {array.length - 1 !== wordIndex ? ' ' : null}
      </React.Fragment>
    );
  });
};
